export function tryToRedirect(path: string): boolean {
    const redirectMapping = redirectMappings.find(
        (m) =>
            (m.from === path || m.from === path + "/") && (!m.hostEndswith || window.location.hostname.endsWith(m.hostEndswith))
    )
    if (redirectMapping) {
        window.location.replace(redirectMapping.to)
    }
    return false
}

const redirectMappings: { from: string; to: string; hostEndswith?: string }[] = [
    { from: "/", to: "/api", hostEndswith: "developer.swiipe.com" },
    { from: "/", to: "/api", hostEndswith: "developer.ecom.aera.id" },
    { from: "/", to: "https://aera-ecom-support.zendesk.com/hc/da", hostEndswith: "docs.swiipe.com" },
    { from: "/", to: "https://aera-ecom-support.zendesk.com/hc/da", hostEndswith: "docs.ecom.aera.id" },
    { from: "/docs", to: "https://aera-ecom-support.zendesk.com/hc/da/categories/11463740811409-Merchant-guides" },
    { from: "/faqs", to: "https://aera-ecom-support.zendesk.com/hc/da/categories/4668733574161-FAQ" },
    {
        from: "/docs/woocommerceinstallationsguide",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11181941123473-How-to-install-Swiipe-plugin-on-your-WooCommerce-webshop",
    },
    {
        from: "/docs/googleautocomplete",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11182237345041-How-to-activate-Google-Autocomplete-on-your-WooCommerce-webshop",
    },
    {
        from: "/docs/activateswiipepayments",
        to: "https://swiipe-support.zendesk.com/hc/da/articles/4572954553745-S%C3%A5dan-aktiverer-du-Swiipes-betalingsmetoder",
    },
    {
        from: "/docs/googleapikey",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11185044519185-How-to-get-a-Google-API-key",
    },
    {
        from: "/docs/activatedeliverymethodswoocommerce",
        to: "https://swiipe-support.zendesk.com/hc/da/articles/4573003795345-S%C3%A5dan-aktiverer-du-leveringsmetoderne-i-WooCommerce",
    },
    {
        from: "/docs/guidetilbetalingslinkwoocommerce",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11461598739729-How-to-create-a-Swiipe-payment-link-in-WooCommerce",
    },
    {
        from: "/docs/plussellguide",
        to: "https://swiipe-support.zendesk.com/hc/da/articles/5681496730513-Guide-til-Plus-Sell-version-2-0-",
    },
    {
        from: "/docs/plussellwoocommerce",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11464990603921-How-to-activate-Swiipe-Plus-Sell-on-your-WooCommerce-webshop",
    },
    {
        from: "/docs/skipthecartchecklist",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11186836391185-Checklist-for-Swiipe-skip-the-cart-feature",
    },
    {
        from: "/docs/magento1installationsguide",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11188165892625-How-to-install-Swiipe-plugin-on-your-Magento-1-9-webshop",
    },
    {
        from: "/docs/magento1funktioner",
        to: "https://swiipe-support.zendesk.com/hc/da/articles/4573248905489-S%C3%A5dan-aktiverer-du-Swiipes-integrationer-og-funktioner-p%C3%A5-din-Magento-1-9-webshop-moms-skat-kuponkoder-Google-Autocomplete-tilpassede-sektioner-",
    },
    {
        from: "/docs/guidetilbetalingslinkmagento1",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11188818536465-How-to-create-a-payment-link-in-Magento-1-9",
    },
    {
        from: "/docs/plussellmagento1",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11532589896849-How-to-activate-Swiipe-Plus-Sell-on-your-Magento-1-9-webshop",
    },
    {
        from: "/docs/magento2installationsguide",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/9592139541649-How-to-install-Swiipe-plugin-on-your-Magento-2-webshop",
    },
    {
        from: "/docs/plussellmagento2",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11532676009873-How-to-activate-Swiipe-Plus-Sell-on-your-Magento-2-webshop",
    },
    {
        from: "/docs/kortbetalingerguide",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11273133250705-How-to-activate-Card-Payments-and-get-Clearhaus-via-Swiipe",
    },
    {
        from: "/docs/kortbetalingerguideudenclearhaus",
        to: "https://swiipe-support.zendesk.com/hc/da/articles/4573406933905-Swiipe-Kortbetalinger-Ikke-kunde-hos-Clearhaus",
    },
    {
        from: "/docs/mobilepayonlineguide",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11271429259921-How-to-activate-Mobilepay",
    },
    {
        from: "/docs/onboardingdankort",
        to: "https://swiipe-support.zendesk.com/hc/da/articles/4573536993297-Dankort-onboarding-guide",
    },
    {
        from: "/docs/plussellhelloretail",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11533957495441-How-to-set-up-Swiipe-Plus-Sell-with-Hello-Retail",
    },
    {
        from: "/docs/plussellclerk",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11534188043281-How-to-set-up-Swiipe-Plus-Sell-with-Clerk",
    },
    {
        from: "/docs/plussellnativesetup",
        to: "https://swiipe-support.zendesk.com/hc/da/articles/4573632073617-S%C3%A5dan-ops%C3%A6tter-du-Swiipe-Plus-Sell-med-standard-funktioner-i-dit-kontrolpanel",
    },
    {
        from: "/docs/bookkeepingtools",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11591510521617-How-to-match-transactions-to-order-IDs-with-Swiipe-Bookkeeping-tool",
    },
    {
        from: "/docs/integrationtilviabill",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11592817547153-How-to-move-your-ViaBill-to-Swiipe",
    },
    {
        from: "/docs/integrationtilstorebuddy",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11592960612369-Integration-to-Storebuddy",
    },
    {
        from: "/docs/integrationtilforbrugsforeningen",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11593042381329-Integration-to-Forbrugsforeningen",
    },
    {
        from: "/docs/integrationtilshipmondo",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11592630424977-Integration-to-Shipmondo",
    },
    {
        from: "/docs/integrationtillagersystem",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11593425166481-Integration-to-Lagersystem",
    },
    {
        from: "/docs/partneronboardingguide",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11149288368401-How-to-become-Swiipe-partner-and-use-the-partner-portal",
    },
    {
        from: "/docs/partnerportalguide",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11149288368401-How-to-become-Swiipe-partner-and-use-the-partner-portal",
    },
    {
        from: "/docs/updateswiipeplugin",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/11588087093777-How-to-update-your-Swiipe-Plugin",
    },

    {
        from: "/faq/suspectedfraud",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4420475058705-Hvad-g%C3%B8r-man-ved-mistanke-om-svindel",
    },
    {
        from: "/faq/howtocancelswiipe",
        to: "https://swiipe-support.zendesk.com/hc/da/articles/4420491524753-Hvordan-annullerer-man-sin-Swiipe-l%C3%B8sning-",
    },
    {
        from: "/faq/icantseedataintheportal",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4420491525649-Hvordan-skifter-man-mellem-sin-e-commerce-og-personlige-konto-i-Swiipe-Portalen",
    },
    {
        from: "/faq/howtoaddmobilepaylogo",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4420491525905-Hvordan-tilf%C3%B8jer-man-Mobilepay-logo",
    },
    {
        from: "/faq/changeinvoicemailportal",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4420491526289-Hvordan-%C3%A6ndrer-man-sin-faktureringsmail",
    },
    {
        from: "/faq/automaticinvoicepayment",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4420491526545-Hvordan-s%C3%A6tter-man-automatisk-betaling-op-til-faktura",
    },
    {
        from: "/faq/addusersinswiipeportal",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4447774591889-Hvordan-tilf%C3%B8jer-man-brugere-i-Swiipe-Portalen",
    },
    {
        from: "/faq/partialcapture",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4570840179985-Hvordan-fungerer-delvis-h%C3%A6vning",
    },
    {
        from: "/faq/partialrefund",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4570989972369-Hvordan-fungerer-delvis-refundering",
    },
    {
        from: "/faq/changepaymentsorder",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4571052943505-Hvordan-%C3%A6ndrer-man-r%C3%A6kkef%C3%B8lgen-af-hvilke-betalingsmetoder-der-bliver-vist-i-checkoutet",
    },
    {
        from: "/faq/howtomovefields",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4571240382481-Hvordan-kan-man-flytte-p%C3%A5-felterne-i-checkoutet",
    },
    {
        from: "/faq/howlongismoneyreserved",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4571245102353-Hvor-l%C3%A6nge-st%C3%A5r-penge-reserveret-i-banken",
    },
    {
        from: "/faq/updatebankorcvrinformation",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4571282147217-Hvordan-%C3%A6ndrer-man-bank-og-eller-virksomheds-oplysninger",
    },
    {
        from: "/faq/testafteronboarding",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/4571317212689-Hvordan-tester-man-efter-en-onboarding-med-Swiipe",
    },

    {
        from: "/docs/releasenoteswoocommerce",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/22069654811921-Aera-former-Swiipe-plugin-features-for-WooCommerce",
    },
    {
        from: "/docs/releasenotesmagento1",
        to: "https://swiipe-support.zendesk.com/hc/da/articles/4573901454737-Swiipe-udgivelsesnoter-til-Magento-1-9",
    },
    {
        from: "/docs/releasenotesmagento2",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/22075357648273-Aera-former-Swiipe-plugin-features-for-Magento-2",
    },
    {
        from: "/docs/releasenotesportal",
        to: "https://aera-ecom-support.zendesk.com/hc/da/articles/42678763766417-Release-notes-for-Aera-Ecommerce-Portal-former-Swiipe-Portal",
    },
    {
        from: "/docs/releasenotessandbox",
        to: "https://swiipe-support.zendesk.com/hc/da/articles/4573964043025-Swiipe-udgivelsesnoter-til-Sandbox",
    },
    {
        from: "/docs/releasenotesapi",
        to: "https://swiipe-support.zendesk.com/hc/da/articles/4573973034129-Swiipe-udgivelsesnoter-til-API",
    },

    {
        from: "/plugins/woocommerce",
        to: "https://swiipe-support.zendesk.com/hc",
    },
]
